export default __webpack_public_path__ + "static/media/SourceSansPro-BoldItalic.ed7f9067.ttf";